var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppOptimizedImage',{staticClass:"inline-block overflow-hidden rounded-full",style:({ width: _vm.size, height: _vm.size }),attrs:{"src":_vm.src,"alt":_vm.alt,"object-fit":"cover","fallback":"avatar"}})}
var staticRenderFns = []

export { render, staticRenderFns }